import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import {
  clearStudyGroups,
  getStudygroupsInfinite,
  userRequestToJoinGroup,
  userCancelRequestStudyGroup,
} from "../../actions/studygroups";
import { noImagePlaceholder } from "../../constants/baseConst";

class AllStudyGroupsUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studygroup_ids: [],
      page: props.page || 1,
      query: {
        title: "",
        all: true,
        per_page: 12,
      },
    };
  }

  componentDidMount() {
    this.loadStudyGroups();
  }

  componentWillUnmount() {
    this.props.clearStudyGroups();
  }

  handleLoadMore = () => {
    this.setState(
      {
        page: this.state.page + 1,
      },
      this.loadStudyGroups
    );
  };

  handleRequestToJoin = (id) => {
    this.props.userRequestToJoinGroup(id);
  };

  handleCancelRequest = (payload) => {
    this.props.userCancelRequestStudyGroup(payload);
  };

  loadStudyGroups = () =>
    this.props.loadStudygroups(this.state.query, this.state.page);

  render() {
    const { studygroups, total_pages, page } = this.props;

    return (
      <div style={{ width: "80%", margin: "auto" }}>
        {!!studygroups.length && (
          <div className="group-card-list">
            {studygroups.map(
              ({ title, id, logo_url, is_request_sended, invite }) => (
                <div className="group-card" key={id}>
                  <img
                    className="group-card-image"
                    src={logo_url || noImagePlaceholder}
                  />
                  <div className="group-card-title">{title}</div>
                  <div className="group-card-button-group">
                    {is_request_sended ? (
                      <button
                        className="group-card-button"
                        onClick={() =>
                          this.handleCancelRequest({
                            groupId: id,
                            inviteId: invite[0].id,
                          })
                        }
                      >
                        Cancel Request
                      </button>
                    ) : (
                      <button
                        className="group-card-button"
                        onClick={() => this.handleRequestToJoin(id)}
                      >
                        Request To Join
                      </button>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        )}
        {page !== total_pages && (
          <a className="more_item" onClick={this.handleLoadMore}>
            Load more
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroups: state.studygroups.studygroups.values,
  query: state.studygroups.studygroups.query,
  page: state.studygroups.studygroups.page,
  total_pages: state.studygroups.studygroups.total_pages,
  count: state.studygroups.studygroups.count,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudygroups: (page, query) =>
    dispatch(getStudygroupsInfinite(page, query)),
  clearStudyGroups: () => dispatch(clearStudyGroups()),
  userRequestToJoinGroup: (groupId) =>
    dispatch(userRequestToJoinGroup(groupId)),
  userCancelRequestStudyGroup: (groupId) =>
    dispatch(userCancelRequestStudyGroup(groupId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllStudyGroupsUser);



// WEBPACK FOOTER //
// ./src/containers/StudyGroups/AllStudyGroupsUser.jsx